import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userInfo: null,
  isvarified: false,
  authReady: false,
  location: null,
  forceLogout: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,

  reducers: {
    loginSuccess: (state, action) => {
      state.userInfo = action.payload.userInfo;
      state.isvarified = true;
      state.authReady = true;
    },

    setSessionUser: (state, action) => {
      state.userInfo = action.payload;
      state.isvarified = true;
      state.authReady = true;
    },

    setAuthReady: (state, action) => {
      state.authReady = action.payload;
    },

    setLocation: (state, action) => {
      state.location = action.payload;
    },

    updateUserInfo: (state, action) => {
      state.userInfo = {
        ...state.userInfo,
        ...action.payload,
      };
    },

    logout: (state) => {
      state.userInfo = null;
      state.isvarified = false;
      state.authReady = true;
      state.forceLogout = false;
      state.location = null;
    },

    triggerForceLogout: (state) => {
      state.forceLogout = true;
    },
  },
});

export const {
  loginSuccess,
  setSessionUser,
  setAuthReady,
  logout,
  updateUserInfo,
  setLocation,
  triggerForceLogout,
} = authSlice.actions;

export default authSlice.reducer;